import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// https://www.npmjs.com/package/vue-cookies
